import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import PropTypes from "prop-types";
import InteractiveIcon from "../InteractiveIcon/index.js";

/**
 * Render an interactive icon as a link. Use this component when the interaction will send the user
 * to a different url.
 *
 * Passes ref to underlying link
 */
const IconLink = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    name,
    size,
    block,
    as,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(InteractiveIcon, _extends({
    ref: ref,
    as: as,
    name: name,
    block: block,
    size: size
  }, rest));
});
IconLink.propTypes = {
  /**
   * Icon name
   */
  name: PropTypes.string.isRequired,
  /**
   * Component to render
   */
  as: PropTypes.elementType,
  /**
   * To determine if icon should have a block display
   */
  block: PropTypes.bool,
  /**
   * Size class
   */
  size: PropTypes.oneOf(['sm', 'md', 'lg'])
};
IconLink.defaultProps = {
  size: null,
  as: 'a'
};
IconLink.displayName = 'IconLink';
export default IconLink;